<template>
  <v-container>
    <v-form
      ref="dateSearch"
      v-model="dateSearchValid"
      class="text-center"
      lazy-validation
    >
      <v-dialog
        ref="datePicker"
        v-model="datePicker"
        :return-value.sync="searchDate"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="searchDate"
            label="選擇日期"
            append-icon="mdi-calendar"
            readonly
            outlined
            :rules="commonRules.requiredRule"
            dense
            v-bind="attrs"
            v-on="on"
            @click:append="datePicker = true"
          />
        </template>
        <v-date-picker
          v-model="searchDate"
          locale="zh"
          :min="new Date().toISOString().slice(0,10)"
          color="primary"
        >
          <!-- <v-spacer />
          <v-btn
            text
            color="primary"
            @click="datePicker = false"
          >
            取消
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.datePicker.save(searchDate)"
          >
            確認
          </v-btn> -->
        </v-date-picker>
      </v-dialog>
      <v-btn
        v-if="isFast"
        style="color: white"
        rounded
        color="primary font-weight-bold"
        @click="search"
      >
        立即搜尋
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { commonRules } from '../module/pages/mixins/CommonRules'

export default {
  mixins: [commonRules],
  props: {
    // searchDate: {
    //   type: [String],
    //   default: null,
    // },
    isFast: {
      type: [Boolean],
      default: null
    },
    isShowBtn: {
      type: [Boolean],
      default: null
    }
  },
  data () {
    return {
      datePicker: false,
      dateSearchValid: true,
      searchDate: ''
    }
  },
  computed: {
    //   date: {
    //     get() {
    //       return "2022-02-10";
    //     },
    //     set() {
    //       if (this.isFast) {
    //         // this.$router.push(`/CampSearchResult/${this.searchDate}`);
    //       } else {
    //         this.$emit("update:searchDate", this.searchDate);
    //       }
    //     },
    //   },
  },
  watch: {
    searchDate (val) {
      if (!this.isFast) {
        this.$emit('getDate', val)
        // debugger
      }
      val && this.$refs.datePicker.save(this.searchDate)
      // this.datePicker = false
    }
  },
  mounted () {
    if (this.$route.params.date) {
      this.searchDate = this.$route.params.date
    }
  },

  methods: {
    search () {
      if (this.$refs.dateSearch.validate()) {
        // if (this.isFast) {
        this.$router.push(`/CampSearchResult/${this.searchDate}`)
        // } else {
        //   debugger
        //   this.$emit("getDate", this.searchDate);
        // }
      }
    }
  }
}
</script>

<style>
</style>
